import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import { AppRouter } from './AppRouter';
render(<HelmetProvider data-id="element-1273">
    <ThemeProvider data-id="element-1274">
      <AppRouter data-id="element-1275" />
    </ThemeProvider>
  </HelmetProvider>, document.getElementById('root'));